import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptReferralLink, adaptReferralStats, adaptReferredUsers} from "./referrals.adapter";
import type {
  ReferralApiResponse,
  ReferralLink,
  ReferralLinkApi,
  ReferralStats,
  ReferralStatsApi,
  ReferredUser,
  ReferredUserApi,
} from "./referrals.types";

export const getMyReferralLinkService = async (): Promise<ReferralLink | null> => {
  const response = await httpRequest<ReferralApiResponse<ReferralLinkApi>>({
    method: "GET",
    url: "/referrals/my-link",
    baseUrl: config.walletApiUrl,
  });
  return adaptReferralLink(response);
};

export const getMyReferralStatsService = async (): Promise<ReferralStats> => {
  const response = await httpRequest<ReferralApiResponse<ReferralStatsApi>>({
    method: "GET",
    url: "/referrals/my-stats",
    baseUrl: config.walletApiUrl,
  });
  return adaptReferralStats(response);
};

export const getMyReferredUsersService = async (): Promise<ReferredUser[]> => {
  const response = await httpRequest<ReferralApiResponse<ReferredUserApi[]>>({
    method: "GET",
    url: "/referrals/my-referred-users",
    baseUrl: config.walletApiUrl,
  });
  return adaptReferredUsers(response);
};

export const connectReferralCodeService = async (referralCode: string): Promise<unknown> => {
  return httpRequest<unknown, {referral_code: string}>({
    method: "POST",
    url: "/referrals/connect",
    baseUrl: config.walletApiUrl,
    body: {referral_code: referralCode},
  });
};
